import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const CategoriesFilter = ({ filter = "", name }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.sessions.filters[filter]);

  const isLoading = useSelector((state) => state.sessions.filtersLoading[filter]);
  const selectedOption = useSelector((state) => state.sessions.selectedFilters[filter]);

  return (
    <div className="select-box-no-width">
      <p>{name}</p>
      {!isLoading ? (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedOption}
          includeFilter
          enableOnly
          height={324}
          includeSelectAll
          numberDisplayed={0}
          onSelectChange={(data) => dispatch(actionCreators.updateCategories({ filter, data }))}
        />
      ) : (
        <LoadingAnimation uiLoader />
      )}
    </div>
  );
};

export default CategoriesFilter;
